import postApiService from 'modules/api/services/post'
import { getApiServiceUrlEnvironmentUtil } from 'modules/environment/utils'
import {
  ERROR_MODEL_CLASS_NAME,
  ERRORS_ENDPOINT
} from 'modules/errors/constants'
import { getObjectUtil } from 'packages/src'

/**
 * Creates a detailed error object.
 * @param  {Error} error
 * @param  {User} currentUser
 * @param  {Object} data
 * @returns {Object}
 */
function createErrorUtil (error, currentUser, data) {
  return {
    ...data,
    content: JSON.stringify(error),
    stack: getObjectUtil(error, 'stack'),
    userId: getObjectUtil(currentUser, 'data.id')
  }
}

/**
 * Saves the given error data remotely.
 * @param  {Object} data
 * @returns {Promise}
 */
function saveErrorUtil (data) {
  // Save the error
  const endpoint = `${getApiServiceUrlEnvironmentUtil()}${(ERRORS_ENDPOINT.CREATE)}`
  return postApiService(endpoint, {
    ...data,
    className: ERROR_MODEL_CLASS_NAME
  })
}

export {
  createErrorUtil,
  saveErrorUtil
}
